import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CookiePreference } from 'src/types/graphql';

@Injectable({ providedIn: 'root' })
export class SignInService {
  signIn: BehaviorSubject<any> = new BehaviorSubject(undefined);
  cookiePreference: CookiePreference;

  onSignIn() {
    this.signIn.next(true);
  }
}
